import PickupScreen from './PickupScreen.container';

export default PickupScreen;